export default "__VITE_ASSET__d1684a08__"